var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgCandidates = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.6663 18.3334H14.9997V16.6667C14.9997 15.286 13.8804 14.1667 12.4997 14.1667H7.49967C6.11897 14.1667 4.99967 15.286 4.99967 16.6667V18.3334H3.33301V16.6667C3.33301 14.3655 5.19849 12.5 7.49967 12.5H12.4997C14.8008 12.5 16.6663 14.3655 16.6663 16.6667V18.3334ZM9.99967 10.8334C7.23825 10.8334 4.99967 8.59479 4.99967 5.83337C4.99967 3.07195 7.23825 0.833374 9.99967 0.833374C12.7611 0.833374 14.9997 3.07195 14.9997 5.83337C14.9997 8.59479 12.7611 10.8334 9.99967 10.8334ZM9.99967 9.16671C11.8406 9.16671 13.333 7.67432 13.333 5.83337C13.333 3.99242 11.8406 2.50004 9.99967 2.50004C8.15872 2.50004 6.66634 3.99242 6.66634 5.83337C6.66634 7.67432 8.15872 9.16671 9.99967 9.16671Z",
    fill: "currentColor"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgCandidates, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/candidates.6e7f7671.svg";
export { ForwardRef as ReactComponent };